import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';

import { Goal, GoalCategory } from './goal.models';
import * as GoalActions from './goal.actions';
import { AppService } from '../../app.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class GoalEffects {
  loadGoals$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GoalActions.loadGoals),
      switchMap(() => {
        return this.goalService
          .get('goals', '', { appId: environment.appId })
          .then((goals: Goal[]) => GoalActions.loadGoalsSuccess({ goals }))
          .catch((error: any) =>
            GoalActions.loadGoalsFailure({ error: error.response })
          );
      })
    );
  });

  loadGoalCategories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GoalActions.loadGoalCategories),
      switchMap(() => {
        return this.goalService.get('goals-categories', '', {appId: environment.appId})
          .then((goalCategories: GoalCategory[]) => GoalActions.loadGoalCategoriesSuccess({ goalCategories }))
          .catch((error: any) => GoalActions.loadGoalCategoriesFailure({error: error.message}))
      })
    );
  })

  constructor(
    private actions$: Actions,
    private goalService: AppService<Goal[]>
  ) {}
}
